import {EnvConfig} from "~/lib/env-config";

export default {
  log(msg) {
    if (EnvConfig("__DEVELOPMENT__")) console.log(msg);
  },
  error(msg) {
    if (EnvConfig("__DEVELOPMENT__")) console.error(msg);
  }
}
